import React, { FC, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { BRANDS, COUNTRY } from "../../../../constants/app";
import Barcode from "react-barcode";
import {
  memberValidationWatcher,
  showPhysicalCardModal,
  showReelClubModal,
} from "../../../../store/auth/action";
import Redeem from "../Redeem";
import PhysicalCard from "../PhysicalCard";

interface ILoyaltyProps {}

const Loyalty: FC<ILoyaltyProps> = () => {
  const { countryId, userDetails, memberDetail, brandId, openSlider } = useSelector(
    (state: RootState) => ({
      countryId: state.applicationReducer.countryId,
      userDetails: state.authReducer.userDetails,
      memberDetail: state.authReducer.memberDetail,
      brandId: state.applicationReducer.brandId,
      openSlider: state.applicationReducer.openSlider, 
    })
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (userDetails && openSlider && openSlider.open && userDetails?.vista_memberid && userDetails?.result?.cardNumber) {
      const payload = {
        MemberRefId: userDetails?.vista_memberid,
        UserSessionId: userDetails?.result?.cardNumber,
        cardNumber: userDetails?.result?.cardNumber,
        countryId: countryId,
        memberId: userDetails?.id,
        emailId: userDetails?.email,
      };
      dispatch(memberValidationWatcher(payload));
    }
  }, [userDetails, openSlider]);

  const txnPoints = useMemo(() => {
    if (
      memberDetail &&
      memberDetail?.LoyaltyMember &&
      memberDetail.LoyaltyMember.BalanceList &&
      memberDetail.LoyaltyMember.BalanceList.length > 0
    ) {
      return memberDetail?.LoyaltyMember?.BalanceList.reduce(
        (total: number, v: any) => {
          total = total + Number(v.PointsRemaining);
          return total;
        },
        0
      )
    } else {
      return 0;
    }
  }, [memberDetail]);

  const redemptionRate = useMemo(() => {
    const points =  memberDetail?.LoyaltyMember?.BalanceList &&
      memberDetail?.LoyaltyMember?.BalanceList.length > 0
      ? memberDetail?.LoyaltyMember?.BalanceList.reduce(
          (total: number, v: any) => {
            total = total + (Number(v.RedemptionRate)*v.PointsRemaining);
            return total;
          },
          0
        )
      : 0;
      return points?(((Math.floor((points*100) / 50)) * 50)/100):0
  }, [memberDetail]);

  const openReelClubModal = () => {
    dispatch(showReelClubModal(true));
  };

  const onClickAddCard = () => {
    dispatch(showPhysicalCardModal(true));
  };

  return (
    <div className={`col-md-12 ${countryId === COUNTRY.AFC?'reel_wrap_afc':'reel_wrap'}`}>
      <div className="section_divided">
        <div className="redeem-card card_top">
          <div className="name">
            {countryId === COUNTRY.STA ? "State Member" : (countryId === COUNTRY.ANG ) ?(memberDetail?.LoyaltyMember?.MemberLevelName)?.replace('Gold','Rewards Gold')?.replace('Club','Rewards Club'):brandId === BRANDS.US?(countryId === COUNTRY.AFC ? "Angelika Membership & Rewards": "Extras Rewards"):"REEL Club"}
            <span className="float-right text-right member-number">
              <div style={{whiteSpace:'nowrap'}}>{countryId === COUNTRY.AFC?'MEMBERSHIP ID NUMBER':'MEMBER NUMBER'}</div>
              <div className="member-no">
                {memberDetail?.LoyaltyMember?.CardNumber}
              </div>
            </span>
          </div>
          {countryId !== COUNTRY.AFC ?<div
            className="col-md-12 text-right text_with_right_arrow px-2"
            onClick={onClickAddCard}
          >
            Add a Physical Card <span className="chevron_right"></span>
          </div>:null}
          {memberDetail && memberDetail?.LoyaltyMember &&  memberDetail?.LoyaltyMember?.CardNumber?<div className="club_bar_code" onClick={() => {}}>
            <Barcode
              width={4}
              height={65}
              displayValue={false}
              value={memberDetail?.LoyaltyMember?.CardNumber!}
            />
          </div>: null}
        </div>
        {countryId === COUNTRY.AFC?<div className="card_bottom">
          <div className="title">My Angelika Membership Points</div>
          <div className="point_desc">
            <div className="points">{txnPoints} <span>Points</span></div>
            <div className="points_amt">${redemptionRate.toFixed(2)} <span>Rewards</span></div>
          </div>
        </div>:
        <div className="card_bottom px-3">
          <div className="col-md-12">
            <div className="points_wrap m-0">
              <div className="points">{txnPoints} Points</div>
            </div>       
          </div>
        </div>}
      </div>
      <Redeem />
      <PhysicalCard />
    </div>
  );
};

export default Loyalty;
